export const flex = (style) => ({
  display: 'flex',
  alignItems: 'stretch',
  ...style,
})

const item = ({grow = 0, shrink = 1, base = 'auto', marginRight = 15} = {}, style = {}) => {
  const flexBase = typeof base === 'number' ? `${base}%` : base

  return ({
    ...style,
    flex: `${grow} ${shrink} ${flexBase}`,
    marginRight: marginRight,
  })
}

export const centered = (style) => ({
  ...flex(style),
  justifyContent: 'flex-start',
})

// TODO: Change it to an object and remove the function call from the views
export const center = () => ({
  ...flex(),
  alignItems: 'center',
})

export const column = (style) => ({
  ...flex(style),
  height: '100%',
  flexDirection: 'column',
})

export const fixed = (style) => ({
  flex: '0 0 auto',
  ...style,
})

export const content = (style) => ({
  flex: '1 1 auto',
  overflow: 'auto',
  ...style,
})

export default {
  flex,
  item,
  center,
  centered,
  column,
  fixed,
  content,
}
